'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);

/**
 * @ngdoc service
 * @name $numberFormat
 * @function
 *
 * @description
 * Number formatter based on numeraljs.
 *
 */
ngModule.factory("$tauxFormat", function (stringUtils) {
  var $tauxFormat = function $tauxFormat(value, fixedDecimals, signed) {
    if (value == null) {
      return "-";
    }
    var isSigned = !_.isUndefined(signed);
    var isFixedDecimals = !_.isUndefined(fixedDecimals);
    var format;
    if (isFixedDecimals) {
      var nbDecimals = parseInt(fixedDecimals);
      format = "0,0." + stringUtils.repeatSequence("0", nbDecimals);
    } else {
      format = "0,0.[00]";
    }
    var res = numeral(value.valeur * 100).format(format) + " %";
    // todo - sans doute à intégrer dans la pattern de format
    if (isSigned) {
      if (numeral(value.valeur) > 0) {
        res = "+" + res;
      }
    }
    if (value.type === 'ESTIME') {
      res += "*";
    }
    return res;
  };
  return $tauxFormat;
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/core/types/taux/tauxFormat.js
// module id = 2735
// module chunks = 13